module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('on-mobile'), _vm._v(" "), _c('loader'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('three-background')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-427a9fc7!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 270
// module chunks = 0